import type { LinkedSequence } from '@frameio/graphql-client/generated/types';
import { useSequenceLinkedAssetFragment } from '../gql/generated/SequenceLinkedAsset';

/**
 * Hook to retrieve the sequences linked to an asset.
 *
 * @param assetId - The unique identifier of the asset to check
 * @returns An object containing:
 *   - `sequences` - All linked sequences (filtered, non-null)
 */
export function useLinkedSequencesForAsset({ assetId }: { assetId: string }) {
  const sequenceData = useSequenceLinkedAssetFragment({
    from: {
      id: assetId,
      __typename: 'Asset',
    },
  })?.data;

  const sequences =
    sequenceData && 'sequences' in sequenceData
      ? sequenceData.sequences ?? []
      : [];
  const filteredSequences = sequences.filter(
    (s): s is LinkedSequence => s != null
  );

  return { sequences: filteredSequences };
}
